import { tsv } from "@faire/slate/lib/tsv";
import React from "react";

type IProps = {
  truncate?: boolean;
  className?: string;
  id?: string;
};

export const ModalTitle: React.FC<React.PropsWithChildren<IProps>> = ({
  children,
  className,
  id,
  truncate,
}) => (
  <h2 className={titleStyle.cls({ truncate, className })} id={id} tabIndex={-1}>
    {children}
  </h2>
);

const titleStyle = tsv({
  base: "fs-modal__title",
  variants: {
    truncate: {
      true: "truncate",
    },
  },
});
